import { render, staticRenderFns } from "./ed-subject-builder-content.component.vue?vue&type=template&id=3984c04e&scoped=true&"
import script from "./ed-subject-builder-content.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-content.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-content.component.scss?vue&type=style&index=0&id=3984c04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984c04e",
  null
  
)

export default component.exports